import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "I did an AMA, and it wasn't crickets.",
  "description": "",
  "published": "2016-10-27T00:00:00.000Z",
  "redirect_from": ["/blog/did-an-ama-wasnt-crickets/swizec/7153"],
  "categories": "O1visa, Personal",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Yesterday, I became old. I'm 29 now, which means I have entered my 30th year. Kinda crazy to think about.`}</p>
    <p>{`Yes, 29 `}<em parentName="p">{`does`}</em>{` mean I'm in my 30th year. My girlfriend didn't believe me, but think about it: Are you in your 0th or your 1st year when you are born?`}</p>
    <p>{`Exactly. Birthdays denote the boundaries between years. Next year, I will have completed my 30th year and I will be 30. This year I am `}<em parentName="p">{`in`}</em>{` my 30th year, and I am 29. Maths.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2016/10/ama.jpg",
        "alt": null
      }}></img></p>
    <p>{`I learned two things yesterday:`}</p>
    <ol>
      <li parentName="ol">{`Taking an appropriate picture is difficult when you're not wearing a shirt.`}</li>
      <li parentName="ol">{`AMAs, even those with just 8 upvotes, are more work than you think.`}</li>
    </ol>
    <p>{`Questions boiled down into two categories: “What makes `}<em parentName="p">{`you`}</em>{` so special that you got the genius visa?” and “Why did you leave Slovenia? Is SF really better?”`}</p>
    <h2 {...{
      "id": "what-makes-you-so-special"
    }}>{`What makes `}<em parentName="h2">{`you`}</em>{` so special?`}</h2>
    <p>{`Nothing. I am not unique. `}<em parentName="p">{`You`}</em>{`, too, can get the "alien with extraordinary ability in X" visa! It's easier than it looks.`}</p>
    <p>{`Unlike the normal `}<a parentName="p" {...{
        "href": "wikipedia"
      }}>{`H1B work visa`}</a>{`, the `}<a parentName="p" {...{
        "href": "wikipedia"
      }}>{`O-1 visa`}</a>{` doesn't involve a lottery. If you send an application, it will be considered. So that's easier.`}</p>
    <p>{`And unlike the H1B, you don't have to graduate college or have a crazy amount of full-time employment experience either. You can get it in one of two ways:`}</p>
    <ul>
      <li parentName="ul">{`have 1 really big thing, like a Nobel prize or being Miss World`}</li>
      <li parentName="ul">{`have very many small things like →`}</li>
    </ul>
    <p>{`Be a visible member of the community (talks, blogs, opensource, `}{`[`}{`self-]published tech books, all the fun stuff); have some friends who can write fancy-sounding recommendation letters (remember, you're visible in the community, you have them); perhaps do some consulting for other companies (freelancing/consulting is increasingly the norm for ambitious young people); and judge the works of others in a professional capacity (you're prominent in the community, selecting talks for conferences counts).`}</p>
    <p>{`Could I have achieved all of that in a big country? Probably not. Did being from a small country with a small tech community help? Infinitely.`}</p>
    <p>{`Longer answers on Reddit `}<a parentName="p" {...{
        "href": "https://www.reddit.com/r/IAmA/comments/59c6el/im_29_been_coding_for_20_years_last_year_the_us/d97984z/"
      }}>{`here`}</a>{`, `}<a parentName="p" {...{
        "href": "https://www.reddit.com/r/IAmA/comments/59c6el/im_29_been_coding_for_20_years_last_year_the_us/d97dggd/"
      }}>{`here`}</a>{`, and `}<a parentName="p" {...{
        "href": "https://www.reddit.com/r/IAmA/comments/59c6el/im_29_been_coding_for_20_years_last_year_the_us/d97dwy9/"
      }}>{`here`}</a>{` and on my blog `}<a parentName="p" {...{
        "href": "https://swizec.com/blog/how-i-got-a-visa-normally-reserved-for-nobel-laureates/swizec/6767"
      }}>{`here`}</a>{`.`}</p>
    <p>{`Oh, and the final ingredient: A lot of `}<em parentName="p">{`"Fuck it, let's try"`}</em>{` when applying.`}</p>
    <h2 {...{
      "id": "why-did-you-leave-slovenia-is-sf-really-better"
    }}>{`Why did you leave Slovenia? Is SF really better?`}</h2>
    <p>{`Slovenia (my hometown, Ljubljana):`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2016/10/ljubljana.jpg",
        "alt": null
      }}></img></p>
    <p>{`San Francisco:`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2016/10/sanfrancisco.jpg",
        "alt": null
      }}></img></p>
    <p>{`In terms of quality of life, San Francisco is a shithole compared to Slovenia. I left because of the economy and the politics.`}</p>
    <p>{`Slovenia is tiny. Like super tiny. 2 million people kind of tiny. And 25 years after becoming a country, it's still a country in transition because these things take time.`}</p>
    <p>{`This brings with it a lot of problems. Our economy is small and extremely export-based. So much so that most of my friends either work for companies who sell to foreign companies, or they do remote work for foreign companies.`}</p>
    <p>{`I figured I might as well go to the foreign lands directly.`}</p>
    <blockquote>
      <p parentName="blockquote">{`Slovenia has seasons, which is nice. It's also a lot more easy going if you want it to. And smaller.`}</p>
      <p parentName="blockquote">{`If I had to use one word to describe SF versus Slovenia, it's "more". There's just more everything. More people, more restaurants to try, more bars to go to, more tech to see, more opportunity to work at interesting companies, more potential to maybe change the world if you get lucky.`}</p>
    </blockquote>
    <p>{`Longer answers on Reddit `}<a parentName="p" {...{
        "href": "https://www.reddit.com/r/IAmA/comments/59c6el/im_29_been_coding_for_20_years_last_year_the_us/d97nd5t/"
      }}>{`here`}</a>{`, `}<a parentName="p" {...{
        "href": "https://www.reddit.com/r/IAmA/comments/59c6el/im_29_been_coding_for_20_years_last_year_the_us/d97abou/"
      }}>{`here`}</a>{`, `}<a parentName="p" {...{
        "href": "https://www.reddit.com/r/IAmA/comments/59c6el/im_29_been_coding_for_20_years_last_year_the_us/d97dis2/"
      }}>{`here`}</a>{`, and `}<a parentName="p" {...{
        "href": "https://www.reddit.com/r/programming/comments/59c7gv/im_29_been_coding_for_20_years_last_year_the_us/d98cic1/"
      }}>{`here`}</a>{`. Also on my blog `}<a parentName="p" {...{
        "href": "https://swizec.com/blog/does-it-make-sense-move-san-francisco/swizec/6805"
      }}>{`here`}</a>{`, and `}<a parentName="p" {...{
        "href": "https://swizec.com/blog/its-good-to-be-back-but-i-still-dont-know-where-i-like-it-more/swizec/6610"
      }}>{`here`}</a></p>
    <p>{`Oh, and there was a great question about self-promotion and sleaziness. But that deserves its own post :)`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      